// Where a font an InDesign file is set in comes from - mirror of backend app/idml/report.py FontSource.
export const FONT_SOURCES = {
  windowsAndMacos: 'windows_and_macos', office: 'office', windows: 'windows', macos: 'macos', free: 'free',
  unknown: 'unknown',
};

// Fonts every reader has: those both systems install, and Microsoft Office's.
const EVERYWHERE = new Set([FONT_SOURCES.windowsAndMacos, FONT_SOURCES.office]);

// A report is worth a dialog when a reader may lack a font or InDesign fails on the text.
export function fontsNeedTelling(report) {
  return report.fonts.some((font) => !EVERYWHERE.has(font.source));
}

export function reportNeedsTelling(report) {
  return report.notes.length > 0 || fontsNeedTelling(report);
}
